import { Button, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import {
  setAgendaLibraryIsOpen,
  setAgendaLibraryThemeType,
} from 'screens/oneOnOneRabbit/InstancePage/slice/OneOnOneInstancePageSlice';

import { MeshMavenGreen } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const TEXT_MAP = {
  BELONGING: 'Belonging',
  MANAGER_EFFECTIVENESS: 'Manager Effectiveness',
  GROWTH: 'Growth',
  PERFORMANCE: 'Performance',
  COLLABORATION: 'Collaboration',
};

const AgendaRecommendations = ({ agendaRecommendations }) => {
  const dispatch = useDispatch();

  // Check if agendaRecommendationsData has some data
  if (agendaRecommendations?.length === 0) {
    return null; // Return nothing if there's no data
  }

  return (
    <Flex
      padding="16px 0px"
      justifyContent="flex-start"
      alignItems="center"
      sx={{
        border: '1px solid #EBEFF3',
        borderRadius: '8px',
        background:
          'linear-gradient(90deg, rgba(0, 142, 240, 0.03) 0%, rgba(236, 59, 100, 0.03) 33.65%, rgba(255, 194, 0, 0.03) 64.90%, rgba(92, 196, 97, 0.03) 100%), #FFF',
      }}
    >
      <MeshMavenGreen boxSize="40px" mr="16px" ml="16px" />
      <Flex flexDirection="column">
        <TextBodyMedium mb="8px">
          Based on your activity in the last four 1:1’s, Maven recommends that you add agenda points related to
        </TextBodyMedium>
        <Flex ml="-4px">
          {agendaRecommendations?.map((value) => {
            const label = TEXT_MAP[value]; // Get the label from TEXT_MAP using the value as the key
            return (
              <Button
                onClick={() => {
                  dispatch(
                    setAgendaLibraryIsOpen({
                      isOpen: true,
                    })
                  );
                  dispatch(
                    setAgendaLibraryThemeType({
                      themeType: value,
                    })
                  );
                }}
                sx={{
                  m: '0px 4px',
                }}
                size="xs"
                color="#1565BC"
              >
                {label}
              </Button>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AgendaRecommendations;
